(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/* global jQuery, Swiper, RS */

(function ($) {
  // WIP: Mega menu.
  jQuery('#site-navigation [data-submenu-mega-menu]').on('mouseenter', function (e) {
    var $subMenu = jQuery(this).find('.mega-menu-dropdown-wrapper').first();
    var submenuOffset = $subMenu.offset();
    if (0 < submenuOffset.left) {
      $subMenu.css('left', '-' + submenuOffset.left + 'px');
    }
  });
  // END: Mega menu.

  // WIP: Woo quantity buttons.
  if (!String.prototype.getDecimals) {
    String.prototype.getDecimals = function () {
      var num = this,
        match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
      if (!match) {
        return 0;
      }
      return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
    };
  }
  jQuery('body').on('click', '.plus, .minus', function () {
    var $this = jQuery(this),
      $qty = $this.closest('.quantity').find('.qty'),
      currentVal = parseFloat($qty.val()),
      max = parseFloat($qty.attr('max')),
      min = parseFloat($qty.attr('min')),
      step = $qty.attr('step');
    if (!currentVal || currentVal === '' || currentVal === 'NaN') {
      currentVal = 0;
    }
    if (max === '' || max === 'NaN') {
      max = '';
    }
    if (min === '' || min === 'NaN') {
      min = 0;
    }
    if (step === 'any' || step === '' || step === undefined || parseFloat(step) == 'NaN') {
      step = '1';
    }
    if ($this.is('.plus')) {
      if (max && (currentVal + parseFloat(step)).toFixed(step.getDecimals()) >= max) {
        $qty.val(max);
      } else {
        $qty.val((currentVal + parseFloat(step)).toFixed(step.getDecimals()));
      }
    } else if (min && (currentVal - parseFloat(step)).toFixed(step.getDecimals()) <= min) {
      $qty.val(min);
    } else if (currentVal > 0) {
      $qty.val((currentVal - parseFloat(step)).toFixed(step.getDecimals()));
    }
    $qty.trigger('change');
  });
  // END: Woo quantity buttons.

  // WIP: Product carousel Swiper.
  // Function that actually builds the swiper.
  var buildSwiperSlider = function buildSwiperSlider(sliderElm) {
    var slidesPerView = sliderElm.querySelectorAll(":scope .products")[0].classList.contains('columns-auto') ? 'auto' : 4,
      swiperOptions = {
        slidesPerView: slidesPerView,
        spaceBetween: 0
      };

    // Prev / next naviation.
    if (!!sliderElm.closest('.rs-product-carousel').querySelectorAll(":scope .rs-swiper-nav")) {
      swiperOptions.navigation = {
        nextEl: sliderElm.closest('.rs-product-carousel').querySelectorAll(":scope .rs-swiper-next")[0],
        prevEl: sliderElm.closest('.rs-product-carousel').querySelectorAll(":scope .rs-swiper-prev")[0]
      };
    }
    return new Swiper(sliderElm, swiperOptions);
  };

  // Get all of the swipers on the page.
  var allSliders = document.querySelectorAll('.swiper-product-carousel');

  // Loop over all of the fetched sliders and apply Swiper on each one.
  allSliders.forEach(function (slider) {
    return buildSwiperSlider(slider);
  });
  // END: Product carousel Swiper.

  // WIP: Hero swiper.
  if (!!document.querySelectorAll('.swiper-hero-slider')) {
    new Swiper(document.querySelectorAll('.swiper-hero-slider')[0], {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-hero-slider .rs-swiper-next',
        prevEl: '.swiper-hero-slider .rs-swiper-prev'
      }
    });
  }
  // END: Hero swiper.

  // WIP: Woo Swatches.
  if (0 < jQuery('.single-product .variations_form').length) {
    var $variationForms = $('.variations_form');
    $variationForms.each(function () {
      var $variationForm = $(this);
      if ($variationForm.data('swatches')) {
        return;
      }
      $variationForm.data('swatches', true);
      if (!$variationForm.data('product_variations')) {
        $variationForm.find('.rs-swatches-product').find('> .rs-swatch').addClass('rs-enabled');
      }
      if ($('.rs-swatches-product > div').hasClass('rs-active')) {
        $variationForm.addClass('variation-swatch-selected');
      }
      $variationForm.on('click', '.rs-swatches-single > .rs-swatch', function () {
        var $this = $(this);
        var value = $this.data('value');
        var id = $this.parent().data('id');
        // const title = $this.data( 'title' );

        resetSwatches($variationForm);
        if ($this.hasClass('rs-active')) {
          return;
        }
        if ($this.hasClass('wd-disabled')) {
          return;
        }
        $variationForm.find('select#' + id).val(value).trigger('change');
        $this.parent().find('.rs-active').removeClass('rs-active');
        $this.addClass('rs-active');
        resetSwatches($variationForm);
      }).on('woocommerce_update_variation_values', function () {
        resetSwatches($variationForm);
      }).on('click', '.reset_variations', function () {
        $variationForm.find('.rs-active').removeClass('rs-active');
      }).on('reset_data', function () {
        var $this = $(this);
        var all_attributes_chosen = true;
        var some_attributes_chosen = false;
        var replaceGallery = true;
        $variationForm.find('.variations select').each(function () {
          var $select = $(this);
          var value = $this.val() || '';
          if (value.length === 0) {
            all_attributes_chosen = false;
          } else {
            some_attributes_chosen = true;
          }
          if ($select.has('wd-changes-variation-image') && $select.val()) {
            replaceGallery = false;
          }
        });
        if (all_attributes_chosen) {
          $this.parent().find('.rs-active').removeClass('rs-active');
        }
        $variationForm.removeClass('variation-swatch-selected');
        $variationForm.find('.woocommerce-variation').removeClass('wd-show');
        resetSwatches($variationForm);
      });
    });
  }
  var resetSwatches = function resetSwatches($variationForm) {
    // If using AJAX.
    if (!$variationForm.data('product_variations')) {
      return;
    }
    $variationForm.find('.variations select').each(function () {
      var select = $(this);
      var swatch = select.parent().find('.rs-swatches-product');
      var options = select.html();
      options = $(options);
      swatch.find('.rs-swatch').removeClass('rs-enabled').addClass('rs-disabled');
      options.each(function () {
        var value = $(this).val();
        if ($(this).hasClass('enabled')) {
          swatch.find('div[data-value="' + value + '"]').removeClass('rs-disabled').addClass('rs-enabled');
        } else {
          swatch.find('div[data-value="' + value + '"]').addClass('rs-disabled').removeClass('rs-enabled');
        }
      });
    });
  };

  // End Woo Swatches.

  // BEGIN: WIP, Toggle size guide.
  jQuery('.wd-open-popup').on('click', function (e) {
    e.preventDefault();
    jQuery(jQuery(this).attr('href')).toggle();
  });
  // END: Toggle size guide.

  // BEGIN: WIP, Header search.

  // END: Header search.
  var searchDebounce;
  jQuery('#rs-header-search__input').on('keyup', function (e) {
    var $this = jQuery(this);
    clearTimeout(searchDebounce);
    searchDebounce = setTimeout(function () {
      var inputValue = $this.val();
      if (3 > inputValue.length) {
        return;
      }
      var data = {};
      data.searchTerm = inputValue;
      jQuery.ajax({
        url: RS.ajaxurl,
        type: 'GET',
        data: {
          action: 'rs_header_search',
          data: data
        },
        success: function success(response) {
          if (true === response.success) {
            if (response.data.product_items) {
              jQuery('.rs-header-search__results-wrapper .products').html(response.data.product_items);
            }
            if (response.data.category_items) {
              jQuery('.rs-header-search__category-list').html(response.data.category_items);
            }
            if (response.data.search_link) {
              jQuery('.rs-header-search__button').attr('href', response.data.search_link);
            }
          } else {
            // TODO.
          }
        },
        error: function error(response) {
          // console.log( response );
        }
      });
    }, 300);
  });

  // BEGIN: Single product gallery.
  if (!!document.querySelectorAll('.swiper-single-product-slider')) {
    var productThumbsGallery = new Swiper(document.querySelectorAll('.swiper-single-product-thumbs-slider')[0], {
      // slidesPerView: 4,
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      centeredSlidesBounds: true,
      loop: true,
      slideToClickedSlide: true
      // watchSlidesProgress: true,
      // navigation: {
      // 	nextEl: '.swiper-hero-slider .rs-swiper-next',
      // 	prevEl: '.swiper-hero-slider .rs-swiper-prev',
      // },
    });
    var productGallery = new Swiper(document.querySelectorAll('.swiper-single-product-slider')[0], {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      // loopAdditionalSlides: 11,
      // centeredSlides: true,
      // navigation: {
      // 	nextEl: '.swiper-hero-slider .rs-swiper-next',
      // 	prevEl: '.swiper-hero-slider .rs-swiper-prev',
      // },
      thumbs: {
        swiper: productThumbsGallery
      }
    });

    // Navigacija slajdera, preko thumbs slajdera, je bagovita. Izgleda da je problem nastao od swiper verzije 11 (primeri sa starijim verzijama rade, npr: https://codepen.io/intotheprogram/pen/PowvWeX)
    // Kombinacija, thumbs slajdera (koji treba da bude uzajamno syncovan sa main slajderom) + loop + centeredSlides ne radi kako treba u svim slucajevima.
    // Resiti kada se odluci tacno kako ce slajder raditi i da li ima potrebe da se promena slika poveze sa promenom varijacija.

    // productGallery.controller.control = productThumbsGallery;
    // productThumbsGallery.controller.control = productGallery;

    // productGallery.on( 'slideChange', ( swiper ) => {
    // 	console.log( swiper );
    // 	productThumbsGallery.slideTo( swiper.activeIndex );
    // } );
  }
  // END: Single product gallery.

  // BEGIN: WIP, Custom print.

  // END: Custom print.
})(jQuery);

},{}]},{},[1]);
